import styled from 'styled-components';
import {device} from '../../styled/device';
import Modal from '../Modal';
import {Button} from '../Button';

export const BasePaymentFormWrapper = styled.div`
  width: 100%;
  margin: 0;
`;

export const BasePaymentFormFields = styled.div`
  &&& {
    display: grid;
    grid-column-gap: 7px;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto auto;
    text-align: center;
    position: relative;
    font-family: Poppins-Medium, sans-serif;

    @media (max-width: ${device.mobileM}) {
      grid-template-columns: 1fr;
      grid-auto-flow: row;
    }
  }
`;

export const CardNumberElementWrapper = styled.div`
    width: 100%;
    outline: none;
    margin: 0;
    font-family: Poppins-Medium, sans-serif;
    font-size: 16px;
    transition: background-color 0.25s ease-in-out, border-color 0.05s ease-in-out;
    color: #353945;
    padding: 0 16px 0 9px;
    box-sizing: border-box;
    border-radius: 7px;
    border: 1px solid #a2a2b4;
    height: 50px; }
    .input.invalid {
      border-color: #F84B7A; }
    .input::placeholder {
      font-family: Poppins-Regular, sans-serif;
      color: #9696B9;
      opacity: 1; }
    .input::-webkit-inner-spin-button, .input::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: 0;
      -moz-appearance: textfield; 
`;

export const HeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 20px 0;
`;
export const HeaderTitle = styled.div`
  font-family: Poppins-Medium, sans-serif;
`;
export const HeaderBrands = styled.div`
  & > img {
    margin-left: 17px;
  }
`;

export const SubmitButton = styled(Button)`
  min-width: 150px;
  justify-content: center;
  margin: 20px auto 0 auto;
`;

export const SubmitButtonMobileWrapper = styled.div`
  margin: 30px 0;

  & .progress {
    display: none;
  }

  @media (max-width: ${device.tablet}) {
    & .progress {
      display: inline;
      font-family: Poppins-Medium, sans-serif;
      font-size: 21px;
      color: #777e90;
    }

    & ${SubmitButton} {
      margin: 0;
    }

    position: fixed;
    margin: 0;
    display: flex;
    justify-content: space-between;
    padding: 16px;
    width: 100%;
    align-items: center;
    background-color: #f7fafc;
    border-top: 1px solid #b1b5c4;
    bottom: 0;
    left: 0;
    z-index: 5;
  }
`;

export const LoadingModal = styled(Modal)`
  &&& .popup-content {
    top: -20px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fbfbfb !important;
    width: 384px !important;
    height: 600px;

    @media (max-width: ${device.tablet}) {
      width: 300px;
      height: 400px;
    }
  }
`;

export const PaymentLoader = styled.img`
  width: 50px;
`;
